<template>
  <div class="login-container">
    <el-card class="login-card">
      <div class="login-header">
        <img src="../assets/LoginLogo.webp" alt="Logo" class="login-logo" />
        <h2>登录</h2>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-position="top">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名">
            <template #prefix>
              <el-icon><User /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" placeholder="请输入密码" type="password">
            <template #prefix>
              <el-icon><Lock /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" block @click="handleLogin">登录</el-button>
        </el-form-item>
        <el-form-item>
          <div class="login-footer">
            <el-link type="info" @click="goToRegister">注册账户</el-link>
<!--            <el-link type="warning" @click="forgotPassword">忘记密码</el-link>-->
          </div>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 摄像头录入图片对话框 -->
    <el-dialog v-model="showCaptureDialog" title="录入人脸图片" width="600px" @close="stopCamera">
      <div class="camera-container">
        <video ref="video" autoplay class="video-preview"></video>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" @click="captureImage">拍照</el-button>
        <el-button @click="stopCamera">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { User, Lock } from "@element-plus/icons-vue";
import axios from "@/axios";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/components/user";

export default {
  name: "LoginView",
  components: { User, Lock },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      showCaptureDialog: false, // 控制录入图片对话框的显示
      rules: {
        username: [{required: true, message: "请输入用户名", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
      },
    };
  },
  methods: {
    handleLogin() {

      this.performLogin();
      // axios
      //     .post("/login/checkFaceImage", {username: this.loginForm.username})
      //     .then((response) => {
      //       if (!response.data.success ) {
      //
      //         ElMessage.warning(response.data.errorMsg);
      //         if(response.data.errorMsg==='用户不存在')
      //           return;
      //         this.openCaptureDialog();
      //         return;
      //       }
      //       this.performLogin();
      //     })
      //     .catch((error) => {
      //       console.error("检查人脸图片失败", error);
      //       ElMessage.error("无法检查人脸图片，请稍后重试");
      //     });
    },
    openCaptureDialog() {
      this.showCaptureDialog = true;
      this.initCamera();
    },
    stopCamera() {
      const video = this.$refs.video;
      if (video && video.srcObject) {
        const stream = video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
        video.srcObject = null;
      }
      this.showCaptureDialog = false;
      ElMessage.info("摄像头已关闭");
    },
    initCamera() {
      const video = this.$refs.video;
      navigator.mediaDevices
          .getUserMedia({video: true})
          .then((stream) => {
            video.srcObject = stream;
          })
          .catch((error) => {
            console.error("无法访问摄像头", error);
            ElMessage.error("无法访问摄像头，请检查设备权限");
          });
    },
    captureImage() {
      const video = this.$refs.video;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      const base64Image = canvas.toDataURL("image/png");

      axios
          .post("/login/uploadFaceImage", {
            username: this.loginForm.username,
            image: base64Image,
          })
          .then((response) => {
            if (response.data.success) {
              ElMessage.success("人脸图片上传成功，请重新登录");
              this.stopCamera();
            } else {
              ElMessage.error(response.data.errorMsg || "上传失败");
            }
          })
          .catch((error) => {
            console.error("上传人脸图片失败", error);
            ElMessage.error("上传失败，请稍后重试");
          });
    },
    performLogin() {
      axios.post("/login", this.loginForm).then((response) => {
        if (response.data.success) {
          ElMessage.success("登录成功");
          const userStore = useUserStore();
          userStore.setUserId(response.data.data.userID);
          localStorage.setItem(
              "authToken",
              response.data.data.token
          );
          if(this.loginForm.password==="123456"){
            alert("你的密码为默认密码请修改密码")
          }
          this.redirectUser(response.data.data);
        } else {
          ElMessage.error(response.data.errorMsg);
        }
      });
    },
    redirectUser(data) {
      const {userID, organizationID, role} = data;
      const routes = {
        "机构管理员": "/MG",
        "学员": "/z",
        "超级管理员": "/super",
        "视频审核管理员": "/v",
      };
      // alert(organizationID)
      this.$router.push({
        path: routes[role] || "/",
        query: {userid: userID,organizationID: organizationID},
      });
    },
    goToRegister() {

      this.$router.push({
        path: "/zc",
      
      });
      // alert("跳转到注册页面");
    },
    forgotPassword() {
      alert("跳转到忘记密码页面");
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #74ebd5, #acb6e5);
}

.login-card {
  width: 400px;
  padding: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-logo {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.login-footer {
  display: flex;
  justify-content: space-between;
}

.camera-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-preview {
  width: 100%;
  border-radius: 8px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}
</style>
